const doEvery = (eles, fn) => {
  Array.isArray(eles) ? eles.forEach(ele => ele && fn(ele)) : fn(eles)
}

export const hide = eles => {
  doEvery(eles, ele => {ele.classList.add('bta-hide')})
}

export const show = eles => {
  doEvery(eles, ele => {ele.classList.remove('bta-hide')})
}

export const toggle = (eles, klss) => {
  doEvery(eles, ele => {ele.classList.toggle(klss)})
}

export const addEventListener = (eles, type, handler) => {
  doEvery(eles, ele => {
    if (ele.addEventListener) {
      ele.addEventListener(type, handler, false);
    } else if (ele.attachEvent) {
      ele.attachEvent("on" + type, handler);
    } else {
      ele["on" + type] = handler;
    }
  })
}